import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiWithdrawalRequestsList, apiWithdrawalRequestsView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/withdrawalRequests/getData', async datas => {
    const { data } = await apiWithdrawalRequestsList(datas)
    return data
})

export const getView = createAsyncThunk('admin/withdrawalRequests/getView', async id => {
    const { data } = await apiWithdrawalRequestsView(id)
    return data
})

export const withdrawalRequestsSlice = createSlice({
    name: 'admin/withdrawalRequests',
    initialState: {
        loading: true,
        view: null,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = null
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData } = withdrawalRequestsSlice.actions

export default withdrawalRequestsSlice.reducer
